import type { TFunction } from 'i18next'

/**
 * Tempo de espera compacto de um chamado ("agora", "12 min", "3 h", "2 d") — o que o atendente precisa para priorizar a
 * fila. `nowMs` é injetável para testes.
 */
export function formatWaitingTime(
  fromIso: string,
  t: TFunction,
  nowMs: number = Date.now(),
): string {
  const from = new Date(fromIso).getTime()
  if (Number.isNaN(from)) {
    return ''
  }

  const minutes = Math.max(0, Math.floor((nowMs - from) / 60_000))
  if (minutes < 1) {
    return t('desk.ticket.waitingNow')
  }

  if (minutes < 60) {
    return t('desk.ticket.waitingMinutes', { count: minutes })
  }

  const hours = Math.floor(minutes / 60)
  if (hours < 24) {
    return t('desk.ticket.waitingHours', { count: hours })
  }

  return t('desk.ticket.waitingDays', { count: Math.floor(hours / 24) })
}
